// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"Faq_faqContainer__aXoU9","title":"Faq_title__2zvFu","faqBox":"Faq_faqBox__1EqkP","singleFaq":"Faq_singleFaq__2D77y","text":"Faq_text__lkTey"};